import { Card, CardContent, Typography, Chip, Box, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

// 👇 ADDED: Helper function to correctly force UTC to IST conversion
const formatOrderTime = (dateStr) => {
  if (!dateStr) return "N/A";

  // Ensure string ends with 'Z' so JS knows it is UTC
  const utcStr = dateStr.endsWith("Z") ? dateStr : `${dateStr}Z`;

  return new Date(utcStr).toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
};

export default function BatchCard({ batch }) {
  const navigate = useNavigate();

  const getStatusColor = (status) => {
    switch (status) {
      case "CREATED": return "default";
      case "ASSIGNED": return "primary";
      case "PICKED_UP": return "warning";
      case "OUT_FOR_DELIVERY": return "info";
      case "DELIVERED": return "success";
      default: return "default";
    }
  };

  return (
    <Card
      sx={{
        cursor: "pointer",
        borderRadius: 3,
        boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
        border: "1px solid",
        borderColor: "divider",
        width: "100%",
        boxSizing: "border-box"
      }}
      onClick={() => navigate(`/batches/${batch.batch_id}`)}
    >
      <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={1}
        >
          {/* Left Info */}
          {/* 🔥 FIX: Added pr={1} to protect right-side elements from collision */}
          <Box flex={1} minWidth={0} pr={1}>
            <Typography variant="h6" fontWeight="bold" sx={{ lineHeight: 1.2, mb: 0.5, wordBreak: "break-word" }}>
              Batch #{batch.batch_id}
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={0.5} noWrap>
              {/* 👇 UPDATED: Applying the IST formatter here 👇 */}
              {formatOrderTime(batch.created_at)}
            </Typography>
            <Typography variant="body2" fontWeight="500" noWrap>
              Total Orders: <Typography component="span" color="primary.main" fontWeight="bold">{batch.total_orders}</Typography>
            </Typography>

            {batch.delivery_boy && (
              <Typography variant="body2" fontWeight="500" mt={1} noWrap>
                👤 {batch.delivery_boy.name}
              </Typography>
            )}
          </Box>

          {/* Right Info */}
          <Box display="flex" flexDirection="column" alignItems="flex-end" gap={1} flexShrink={0}>
            <Chip
              label={batch.status}
              color={getStatusColor(batch.status)}
              size="small"
              sx={{ fontWeight: "bold", fontSize: "0.7rem", height: 22 }}
            />
            <Chip
              label={batch.ready_status.replace("_", " ")}
              color={batch.ready_status === "FULL_READY" ? "success" : "warning"}
              size="small"
              sx={{ fontWeight: "bold", fontSize: "0.7rem", height: 22 }}
            />
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}